import { createFileRoute } from "@tanstack/react-router"
import { NotFound } from "@/components/shared/errors/not-found"

export const Route = createFileRoute("/_authenticated/$")({
	component: NotFound,
})
